import { type FC } from "react";

import { t } from "i18n/i18n";
import { Button } from "mds/components/Button";
import { CourseCodeWithGroupingType } from "store/selectors/types";

type MoveCourseCodesConfirmationModalProps = {
  courseCodes: CourseCodeWithGroupingType[];
  onConfirm: () => void;
  onCancel: () => void;
};

export const MoveCourseCodesConfirmationModal: FC<MoveCourseCodesConfirmationModalProps> = ({
  courseCodes,
  onConfirm,
  onCancel,
}) => {
  return (
    <div className="mt-8 flex flex-col gap-8">
      <div className="flex flex-col gap-4">
        <div>{t("home.course_codes.move_course_codes_confirmation_label")}</div>

        <div className="flex flex-col gap-2 border-l-2 border-score-1">
          {courseCodes.map((courseCode) => (
            <div className="pl-4" key={courseCode.id}>
              {courseCode.title} {" - "}
              {courseCode.groupingTitle}
            </div>
          ))}
        </div>

        <div>{t("home.course_codes.move_course_codes_confirmation_question")}</div>
      </div>

      <div className="flex w-full justify-end gap-2">
        <Button kind="white" size="s" title={t("common.cancel")} onClick={onCancel}>
          {t("common.cancel")}
        </Button>

        <Button
          kind="red"
          size="s"
          title={t("home.course_codes.move_course_codes_title")}
          onClick={onConfirm}
        >
          {t("home.course_codes.move_course_codes_title")}
        </Button>
      </div>
    </div>
  );
};
